const TEST_IDS = {
  // User Module
  ADDRESS_LIST: "address-list",
  ADDRESS_CARD: "address-card",
  DEFAULT_ADDRESS_CARD: "default-address-card",
  PAYMENT_DETAILS_EMPTY_STATE: "payment-details-empty-state",
  EMPTY_ADDRESSES_STATE: "empty-addresses-state",
  WISHLIST_EMPTY_STATE: "wishlist-empty-state",
  ADDRESS_CARDS: "address-cards",
  ORDER_CELL: "order-cell",
  ORDER_STATUS: "order-status",
  ORDER_ACTIVE_STATUS: "order-active-status",
  TRACK_ORDER_BTN: "track-order-btn",
  TRACK_ORDER_MODAL: "track-order-modal",
  NO_ACTIVE_ORDERS_PLACEHOLDER: "no-active-orders-placeholder",
  NO_ORDER_HISTORY_PLACEHOLDER: "no-order-history-placeholder",
  CANCEL_ORDER_BUTTON: "cancel-order-button",
  CONFIRM_CANCEL_ORDER_BUTTON: "confirm-cancel-order-button",
  // Product Module
  CATEGORY_LINK: "category-link",
  BRANDS_LINK: "brands-link",
  CATEGORIES_MENU: "categories-dropdown",
  NAV_MENU_ITEM: "nav-menu-item",
  TITLE_BAR: "tile-bar",
  FILTER_PILLS_BAR: "filter-pills-bar",
  FILTER_PILL: "filter-pill",
  EMPTY_CART_INDICATOR: "empty-cart-indicator",
  PRODUCT_DETAILS: "product-details",
  PRODUCT_CARD: "product-card",
  WISHLIST_BUTTON: "wishlist-button",
  PRODUCT_REVIEW_ACCORDION: "product-review-accordion",
  PRODUCT_REVIEW_BUTTON: "product-review-button",
  REVIEW_STARS: "review-stars",
  RATING_STARS: "rating-stars",
  REVIEW_INPUT: "review-input",
  SUBMIT_REVIEW_BUTTON: "submit-review-button",
  REVIEW_CONFIRMATION: "review-confirmation",
  PRODUCT_EMPTY_STATE: "product-empty-state",
  // Filter Module
  FILTER_CONTAINER: "filter-container",
  FILTER_CLOSE_BUTTON: "filter-close-button",
  FILTER_ACCORDION: "filter-accordion",
  FILTER_ACCORDION_TOGGLE: "filter-accordion-toggle",
  FILTER_OPTION_CHIP: "filter-option-chip",
  FILTER_CHECKBOX: "filter-checkbox",
  FILTER_CLEAR_ALL: "filter-clear-all",
  FILTER_APPLY_BUTTON: "filter-apply-button",
  PRICE_RANGE_SLIDER: "price-range-slider",
  RATING_FILTER_CHECKBOX: "rating-filter-checkbox",
  PRICE_ATOM: "price-atom",
  RATING_ATOM: "rating-atom",
  FILLED_STAR: "filled-star",
  // Checkout Module
  CART_ITEM_COUNT: "cart-item-no",
  CART_BUTTON: "cart-button",
  PROCEED_TO_CHECKOUT_BUTTON: "procced-to-checkout-button",
  //Order Module
  PLACE_ORDER_BUTTON: "place-order-button",
  ORDER_PLACED_PAGE: "order-placed-page",
  ACCORDION_BUTTON: "accordion-btn",
};

export default TEST_IDS;
